import * as DraftJS from 'draft-js';

export const ROOT_REFERENCE = '{{ NEXXT_ROOT }}';

export const DEFAULT_TEXT = {
    QUESTION: {
        TRADE_OFF: {
            TITLE: 'Tradeoff',
            QUESTION_LABEL: 'Liking Question',
            QUESTION_TEXT: 'Do you like it?',
            ALTERNATIVE_QUESTION_LABEL: 'Trade-off Question',
            ALTERNATIVE_QUESTION_TEXT: 'Which one do you like better?',
            FOLLOWUP_LIKE_TEXT: 'Could you tell me why you like it the best?',
            FOLLOWUP_DISLIKE_TEXT: 'Can you tell me why you do not like this?',
            UPLOADER_SUBLABEL: '(You can upload 5-30 images)'
        },
        VIDEO_ANNOTATION: {
            TITLE: 'In-video annotation',
            QUESTION_TEXT:
                '<p>I’d like you to watch closely 👀 scene by scene, and click <b>ADD COMMENT</b> any time when you feel you like what you see, dislike, or are confused by something in the ad. I’d REALLY love it if you could share your reactions and comments on <b>at least 3 moments / scenes / elements in the ad</b>. You can rewind the video by clicking on the progress bar.</p>',
            ALTERNATIVE_QUESTION_LABEL: 'Comment text',
            ALTERNATIVE_QUESTION_TEXT:
                'How did you feel at this part of the video?'
        },
        HOTSPOT: {
            NOTES: 'The current number of enabled spots: {{ NEXXT }}. Make sure that you click the image to confirm the areas ',
            WARN_NOTES:
                'You do not appear to have any hotspots. You can add an area by clicking the button below.',
            EMPTY_NOTES: 'Please upload your image first',
            CV_PROCESSING:
                'We are processing auto object-detection from your image'
        },
        NPS: {
            TITLE: 'NPS',
            QUESTION_TEXT_LABEL: 'NPS Question Text',
            QUESTION_TEXT:
                'How likely are you to recommend us to a friend or colleague?',
            FOLLOWUP_DETRACTORS_TEXT: `What would make you more likely to recommend us? Your feedback will help us to improve.`,
            FOLLOWUP_PASSIVES_TEXT: `Could you tell me what are the reasons for the score of ${ROOT_REFERENCE} out of 10?`,
            FOLLOWUP_PROMOTER_TEXT: `We’re thrilled you feel that way. Could you tell us why would you like to recommend us?`,
            FOLLOWUP_PROMOTER_LABEL: 'Follow up question for positive feedback',
            FOLLOWUP_PROMOTER_SUBTITLE:
                'This question will be asked among Promoter and Passive',
            FOLLOWUP_DETRACTORS_LABEL:
                'Follow up question for negative feedback',
            FOLLOWUP_DETRACTORS_SUBTITLE:
                'This question will be asked among Detractor and Passive'
        },
        TREEMAN: {
            WANR_NOTES:
                'Please define the selection area and do not forget to add a label for each area'
        },
        TEXT_HIGHLIGHTER: {
            ALTERNATIVE_QUESTION_LABEL: 'Content to be highlighted'
        }
    },
    FOLLOWUPTEXTS: {
        LIKE_LABEL: 'Reason for Like',
        FAVOURITES_LABEL: 'Reason for Favourite',
        CONFUSED_LABEL: 'Reason for Confused',
        DISLIKE_LABEL: 'Reason for Dislike'
    }
};

export const FOLLOW_UP_TEXTS = {
    TRADE_OFF: [
        {
            keyName: 'followUpTextsLike',
            label: DEFAULT_TEXT.FOLLOWUPTEXTS.FAVOURITES_LABEL,
            text: DEFAULT_TEXT.QUESTION.TRADE_OFF.FOLLOWUP_LIKE_TEXT
        },
        {
            keyName: 'followUpTextsDislike',
            label: DEFAULT_TEXT.FOLLOWUPTEXTS.DISLIKE_LABEL,
            text: DEFAULT_TEXT.QUESTION.TRADE_OFF.FOLLOWUP_DISLIKE_TEXT
        }
    ],
    // value is for checking if buttons are enabled/disabled(compared to button value)
    HOTSPOT: [
        {
            keyName: 'followUpTextsLike',
            label: DEFAULT_TEXT.FOLLOWUPTEXTS.LIKE_LABEL,
            text: '',
            value: '1'
        },
        {
            keyName: 'followUpTextsConfused',
            label: DEFAULT_TEXT.FOLLOWUPTEXTS.CONFUSED_LABEL,
            text: '',
            value: '2'
        },
        {
            keyName: 'followUpTextsDislike',
            label: DEFAULT_TEXT.FOLLOWUPTEXTS.DISLIKE_LABEL,
            text: '',
            value: '3'
        }
    ],
    NPS: [
        {
            keyName: 'followUpTextsLike',
            label: DEFAULT_TEXT.QUESTION.NPS.FOLLOWUP_PROMOTER_LABEL,
            helperText: DEFAULT_TEXT.QUESTION.NPS.FOLLOWUP_PROMOTER_SUBTITLE,
            text: DEFAULT_TEXT.QUESTION.NPS.FOLLOWUP_PROMOTER_TEXT
        },
        {
            keyName: 'followUpTextsDislike',
            label: DEFAULT_TEXT.QUESTION.NPS.FOLLOWUP_DETRACTORS_LABEL,
            helperText: DEFAULT_TEXT.QUESTION.NPS.FOLLOWUP_DETRACTORS_SUBTITLE,
            text: DEFAULT_TEXT.QUESTION.NPS.FOLLOWUP_DETRACTORS_TEXT
        }
    ]
};

export const RBC_VIDEO_TEMPLATE_QUESTION_TEXTS = [
    {
        label: 'Early stage development',
        value: '<p>Now for the fun stuff.😉 I’d like to show you <b>an early stage ad</b> that RBC Royal Bank is working on and I’ll ask for your opinions on their behalf - and thank you in advance on their behalf, too!🤜 🤛 </p>'
    },
    {
        label: 'Rough cut/ unfinished format',
        value: '<p>Now for the fun stuff.😉 I’d like to show you <b>an ad in rough cut/unfinished format</b> that RBC Royal Bank is working on and I’ll ask for your opinions on their behalf - and thank you in advance on their behalf, too! 🤜 🤛</p>'
    },
    {
        label: 'Finished ad',
        value: '<p>Now for the fun stuff. 😉 I’d like to show you an ad from RBC Royal Bank and I’ll ask for your opinions on their behalf - and thank you in advance on their behalf, too! 🤜 🤛 </p>'
    }
];
